import { Default } from './status.default'
import { Document } from './status.document'
import { VendorAcceptance } from './status.vendorAcceptance'

const Status = () => 'Please, provide form component'

Status.Default = Default
Status.Document = Document
Status.VendorAcceptance = VendorAcceptance

export default Status
